export default [
    // menú principal. Click 0
    [
    { id: '1', indexList: 1, texto: 'Consulta de datos', image: 'consulta_datos.png', image_h: 'consulta_datos_h.png', route: '' },
    { id: '2', indexList: 2, texto: 'Panel de usuarios', image: 'info_usuario.png', image_h: 'info_usuario_h.png', route: '' },
    { id: '3', indexList: null, texto: 'Página principal', image: '4.png', image_h: '4_h.png', route: '' },
    { id: '4', indexList: null, texto: 'Cerrar sesión', image: 'cerrar_sesion.png', image_h: 'cerrar_sesion_h.png', route: '' }
    ],
    // Consulta de datos. Click 1
    [
      { id: '5', indexList: null, texto: 'Climatológicos', image: 'hidromet.png', image_h: 'hidromet_h.png', route: '/hidroQuery' },
      { id: '6', indexList: null, texto: 'Calidad del aire - inmisión', image: 'calidadaire_in.png', image_h: 'calidadaire_in_h.png', route: '/airQualityInQuery' },
      { id: '7', indexList: null, texto: 'Calidad del aire - emisión', image: 'calidadaire_em.png', image_h: 'calidadaire_em_h.png', route: '/airQualityEmQuery' },
      { id: '8', indexList: null, texto: 'Aguas subterráneas', image: 'aguassub.png', image_h: 'aguassub_h.png', route: '/groundWaterQuery' },
      { id: '9', indexList: null, texto: 'Hidrológicos', image: 'hidrologico.png', image_h: 'hidrologico_h.png', route: '/hydrologicalQuery' },
      { id: '10', indexList: 0, texto: 'Volver', image: 'back.png', image_h: 'back_h.png', route: '/' }
    ],
    // Panel de usuarios. Click 2
    [
      { id: '11', indexList: null, texto: 'Borrar usuario', image: 'borrar_usuario.png', image_h: 'borrar_usuario_h.png', route: '/DeleteUser'},
      { id: '12', indexList: null, texto: 'Editar usuario', image: 'modificar_usuario.png', image_h: 'modificar_usuario_h.png', route: '/UpdateUser'},
      { id: '13', indexList: null, texto: 'Crear usuario', image: 'crear_usuario.png', image_h: 'crear_usuario_h.png', route: '/CreateUser'},
      { id: '14', indexList: 0, texto: 'Volver', image: 'back.png', image_h: 'back_h.png', route: '/' }
    ]
]